import { render, staticRenderFns } from "./KanbanPage.vue?vue&type=template&id=3997e8a6&scoped=true"
import script from "./KanbanPage.vue?vue&type=script&lang=js"
export * from "./KanbanPage.vue?vue&type=script&lang=js"
import style0 from "./KanbanPage.vue?vue&type=style&index=0&id=3997e8a6&prod&scoped=true&lang=css"
import style1 from "./KanbanPage.vue?vue&type=style&index=1&id=3997e8a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3997e8a6",
  null
  
)

export default component.exports